import { render, staticRenderFns } from "./ScreenConfigureRestore.vue?vue&type=template&id=29a13654&scoped=true"
import script from "./ScreenConfigureRestore.vue?vue&type=script&lang=js"
export * from "./ScreenConfigureRestore.vue?vue&type=script&lang=js"
import style0 from "./ScreenConfigureRestore.vue?vue&type=style&index=0&id=29a13654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a13654",
  null
  
)

export default component.exports